import type { ChangeRequestDataObject, ChangeRequestKind, ChangeRequestStatus } from './service';

export class ChangeRequest {
  createdAt: Date;
  createdUser: {
    fullName: string;
    id: string;
  };
  id: string;
  kind: ChangeRequestKind;

  meta: {
    birthdate?: string;
    firstName?: string;
    invitationEmail?: string;
    invitationPhone?: string;
    invitationToken?: string;
    lastName?: string;
    reasonToJoin?: string;
  };

  status: ChangeRequestStatus;
  subject: {
    name: string;
    subjectId: string;
    subjectType: string;
  };
  updatedAt: string;

  constructor(data: ChangeRequestDataObject) {
    this.id = data.id;
    this.createdAt = new Date(data.created_at);
    this.updatedAt = data.updated_at;
    this.subject = {
      name: data.subject.name,
      subjectId: data.subject.subject_id,
      subjectType: data.subject.subject_type,
    };
    this.createdUser = {
      fullName: data.created_user.full_name,
      id: data.created_user.id,
    };
    this.kind = data.kind;
    this.status = data.status;
    this.meta = {
      birthdate: data.meta.birthdate,
      firstName: data.meta.first_name,
      invitationEmail: data.meta.invitation_email,
      invitationPhone: data.meta.invitation_phone,
      invitationToken: data.meta.invitation_token,
      lastName: data.meta.last_name,
      reasonToJoin: data.meta.reason_to_join,
    };
  }
}

export const getLastChangeRequestStatus = (changeRequests?: ChangeRequest[]) =>
  changeRequests?.toSorted((a, b) => a.createdAt.getTime() - b.createdAt.getTime())[changeRequests.length - 1]?.status;
